import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileComponent } from './file.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FileComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [FileComponent]
})
export class FileModule { }
